<template>
    <div>
        <span class="body-2"><b>{{ dataItem.name }}:</b></span>
        <span class="body-1" v-html="linkOrValue"></span>
    </div>
</template>

<script>

import httpClient from '@/api/http-client'

const http = httpClient.http

const ERROR_DOWNLOAD = 'Ошибка загрузки'
const ERROR_FILE_NOT_FOUND = 'Файл не найден'

/**
 *
 *
 */
export default {

    name: "DataItemRow",

    props: {
        dataItem: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            title: ''
        };
    },

    /**
     *
     *
     */
    mounted() {

        if ( this.dataItem.type === 9 ) {

            if ( this.dataItem.value ) {

                http.post( `/disk/v1/token/info/`, {
                    token: this.dataItem.value,
                }).then( response => {

                    const { data } = response

                    if ( response.status === 200 && data && data.name && data.token ) {
                        this.title = `<a href="/disk/d/${ data.token }" target="_blank">${ data.name }</a>`
                    }
                    else {
                      this.title = ERROR_DOWNLOAD
                    }
                } ).catch( () => {
                    this.title = ERROR_DOWNLOAD
                } );
            }
            else {
              this.title = ERROR_FILE_NOT_FOUND
            }
        }
        else {
          this.title = this.dataItem.value
        }
    },

  /**
   *
   */
  computed: {

    linkOrValue: {
        get() {
            return this.title
        },
        set( newVal ) {
            this.title = newVal
        }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/apps/bpm/components/DataItemRow.vue